export const ListsEditHeaders = [
  { label: "", map: "", options: { copy: true, sort: false } },
  { label: "#", map: "serial", options: { sort: false } },
  { label: "Image", map: "image", options: { sort: false } },
  { label: "Tag", map: "tag", options: { sort: false } },
  { label: "Title", map: "title", options: { sort: true } },
  { label: "Display Value", map: "display_value", options: { sort: true, infoMessage: "Display value will show on the runtime in any application. If its empty it shows the default title. " } },
  { label: "Math Value", map: "math_value", options: { sort: false, infoMessage: "Numeric field used for calculation in rules. If empty, text value will be used." } },
  { label: "Show/Hide", map: "visibility", options: { sort: false } },
  { label: "Help Text", map: "visibility", options: { sort: false } },
  { label: "", map: "", options: { copy: true, sort: false } },
];
export const CREATE: string = "Create";
export const LISTS: string = "Lists";
export const SAVE: string = "Save"
export const CANCEL: string = "Cancel"
export const LISTS_ROUTE: string = "/gms/lists"
export const ADD_NEW: string = "Add New"
export const ITEMS: string = "Items"
export const LIST_NAME: string = "List Name"
export const LIST_CREATE: string = "gmslist_create";
export const LIST_READ: string = "gmslist_read";
export const LIST_UPDATE: string = "gmslist_update";
export const LIST_DELETE: string = "gmslist_delete";
export const LIST_TRANSFER: string = "gmslist_transfer";
export const CHANGE_OWNER: string = "Change Owner";
export const SEARCH_PLACEHOLDER: string = "Search lists";
